import React from 'react';
import { cn } from '@/lib/utils';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
    size?: 'sm' | 'md' | 'lg' | 'icon';
}

export function Button({
   className,
   variant = 'primary',
   size = 'md',
   ...props
}: ButtonProps) {
    return (
        <button
            className={cn(
                "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand-gold disabled:pointer-events-none disabled:opacity-50",
                // Variants
                variant === 'primary' && "bg-brand-gold text-black hover:bg-brand-gold/90 shadow-sm",
                variant === 'secondary' && "bg-zinc-800 text-brand-mist hover:bg-zinc-700",
                variant === 'outline' && "border border-zinc-700 bg-transparent hover:bg-zinc-800 text-brand-mist",
                variant === 'ghost' && "hover:bg-zinc-800 text-brand-mist",
                // Sizes
                size === 'sm' && "h-8 px-3 text-xs",
                size === 'md' && "h-10 px-4 py-2 text-sm",
                size === 'lg' && "h-12 px-8 text-base",
                size === 'icon' && "h-10 w-10",
                className
            )}
            {...props}
        />
    );
}
